import React, { useEffect, useState } from "react";
import {
  CustomButton2,
  CustomDropdownSearch,
  CustomInput,
  CustomView,
} from "../../../../../../../../components";
import styles from "./style.module.sass";
import {
  ICityItem,
  IItem,
  IProvinceItem,
} from "../../../../../../../../types/common.interface";
import { useQuery } from "react-query";
import values from "../../../../../../../../values";
import api from "../../../../../../../../api";
import { useTranslation } from "react-i18next";
import Context from "../../../../../../../../context";

interface IParent {
  phoneNumber: string;
  firstName?: string;
  province?: string;
  lastName?: string;
  gender?: string;
  city?: string;
}

type Props = {
  values: IParent;
  isLoading: boolean;
  onSubmit: (values: IParent) => void;
  onClose: () => void;
};

const CreateOrUpdateParent: React.FC<Props> = (
  props: Props
): React.ReactElement => {
  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { t } = useTranslation();
  const { selectedDriver } = React.useContext(Context.DriverScreen);

  console.log({ selectedDriver });

  const [showMoreInfo, setShowMoreInfo] = React.useState<boolean>(false);
  const [selectedGender, setSelectedGender] = React.useState<any>(
    values.dropdownItems.GENDER.find(
      (item) => item.value === props.values?.gender
    )
  );
  const [selectedProvince, setSelectedProvince] = React.useState<
    IProvinceItem | undefined
  >(undefined);
  const [selectedCity, setSelectedCity] = React.useState<any>(undefined);
  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    gender: "",
  });

  const [firstName, setFirstName] = React.useState<string | undefined>(
    props.values?.firstName
  );
  const [lastName, setLastName] = React.useState<string | undefined>(
    props.values.lastName
  );

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
    api.get.common.getAllProvince()
  );

  const getAllCity = useQuery(
    [values.useQueryKeys.getAllCity, selectedProvince],
    () => api.get.common.getAllCity({ provinceCode: selectedProvince?.Code })
  );

  useEffect(() => {
    if (getAllProvince.data.result) {
      setSelectedProvince(
        getAllProvince.data.result?.find(
          (item: any) =>
            item._id === selectedDriver.schoolDriverInformation.province
        )
      );
    }
  }, [getAllProvince, selectedDriver.schoolDriverInformation.province]);

  useEffect(() => {
    if (getAllCity.data.result) {
      setSelectedCity(
        getAllCity.data.result?.find(
          (item: any) =>
            item._id === selectedDriver.schoolDriverInformation.city
        )
      );
    }
  }, [getAllCity, selectedDriver.schoolDriverInformation.city]);

  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function handelOnSubmit(): void {
    if (!lastName || lastName?.length < 3)
      setErrors({ ...errors, lastName: "نام خانوادگی اجباری است" });
    if (!firstName || firstName?.length < 3)
      setErrors({ ...errors, firstName: "نام اجباری است" });

    if (!selectedGender) setErrors({ ...errors, gender: "جنسیت اجباری است" });

    if (firstName && lastName && selectedGender) {
      props.onSubmit({
        phoneNumber: props.values.phoneNumber,
        firstName,
        province: selectedProvince?._id,
        lastName,
        gender: selectedGender?.value,
        city: selectedCity?._id,
      });
    }
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <CustomView.Container className={styles.createOrUpdateParentContainer}>
      <CustomView.Row className={styles.title}>مشخصات اولیاء</CustomView.Row>
      <CustomView.Row className={styles.body}>
        <CustomView.Column medium={10}>
          <CustomView.Row>
            <CustomView.Column medium={6}>
              <CustomInput
                isDisable
                label={"شماره موبایل اولیا‌ء"}
                value={`0${props.values.phoneNumber}`}
                textAlign={"center"}
              />
            </CustomView.Column>
            <CustomView.Column medium={6}>
              <label className={styles.label}>انتخاب جنسیت</label>
              <CustomDropdownSearch
                items={values.dropdownItems.GENDER}
                itemName="name"
                placeHolder={t("selectGender")}
                defaultItem={selectedGender}
                onSelectItem={(event: any) => {
                  setSelectedGender(event);
                  setErrors({ ...errors, gender: "" });
                }}
              />
              <div className={styles.error}>
                {errors.gender !== "" && errors.gender}
              </div>
            </CustomView.Column>
          </CustomView.Row>
          <CustomView.Row>
            <CustomView.Column medium={6}>
              <CustomInput
                isRequired
                label={"نام"}
                value={firstName}
                onValueChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setFirstName(event.target.value);
                  setErrors({ ...errors, firstName: "" });
                }}
                error={errors.firstName !== ""}
                errorText={errors.firstName}
              />
            </CustomView.Column>
            <CustomView.Column medium={6}>
              <CustomInput
                isRequired
                label={"نام خانوادگی"}
                value={lastName}
                onValueChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setLastName(event.target.value);
                  setErrors({ ...errors, lastName: "" });
                }}
                error={errors.lastName !== ""}
                errorText={errors.lastName}
              />
            </CustomView.Column>
          </CustomView.Row>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div
              className="more-info"
              onClick={() => {
                setShowMoreInfo(!showMoreInfo);
              }}
              style={{
                fontSize: "12px",
                cursor: "pointer",
                padding: "1rem",
                width: "8rem",
              }}
            >
              {t("more_info")} <i className={"fa-solid fa-chevron-down"}></i>
            </div>
          </div>
          {showMoreInfo && (
            <CustomView.Row>
              <CustomView.Column medium={6}>
                <label className={styles.label}>انتخاب استان</label>
                <CustomDropdownSearch
                  items={getAllProvince?.data?.result}
                  itemName="Name"
                  defaultItem={selectedProvince}
                  onSelectItem={(event: IProvinceItem) =>
                    setSelectedProvince(event)
                  }
                  placeHolder={t("selectProvince")}
                  isLoading={getAllProvince.isLoading}
                  isSearch
                />
              </CustomView.Column>
              <CustomView.Column medium={6}>
                <label className={styles.label}>انتخاب شهر</label>
                <CustomDropdownSearch
                  items={getAllCity?.data?.result}
                  itemName="Name"
                  defaultItem={selectedCity}
                  onSelectItem={(event: ICityItem) => setSelectedCity(event)}
                  placeHolder={t("selectCity")}
                  isLoading={getAllCity.isLoading}
                  isSearch
                />
              </CustomView.Column>
            </CustomView.Row>
          )}
          <CustomView.Row className={styles.footer}>
            <CustomView.Column medium={6}>
              <CustomButton2
                title="تایید"
                onClick={handelOnSubmit}
                isLoading={props.isLoading}
              />
            </CustomView.Column>
            <CustomView.Column medium={6}>
              <CustomButton2
                title="لغو"
                type={"danger"}
                onClick={props.onClose}
              />
            </CustomView.Column>
          </CustomView.Row>
        </CustomView.Column>
      </CustomView.Row>
    </CustomView.Container>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default CreateOrUpdateParent;
